export const getLocalStorage = (key: string) => (localStorage.getItem(key))

export const setLocalStorage = (key: string, value: any) => (localStorage.setItem(key, value));

export const deleteLocalStorage = (key: string) => (localStorage.removeItem(key));

export const clearLocalStorage = () => (localStorage.clear());

export const replacekeyLocalStorage = (oldKey: string, newKey: string) => {
  const oldKeyValue = getLocalStorage(oldKey)
  const newKeyValue = getLocalStorage(newKey)

  if (newKeyValue) {
    if (oldKeyValue !== null || oldKeyValue !== undefined) {
      deleteLocalStorage(oldKey)
    }
    return getLocalStorage(newKey)
  }

  if (oldKeyValue === null || oldKeyValue === undefined) {
    deleteLocalStorage(oldKey)
    return getLocalStorage(newKey)
  }

  if (oldKeyValue) {
    setLocalStorage(newKey, oldKeyValue)
    deleteLocalStorage(oldKey)
  }

  return getLocalStorage(newKey)
}